export default [
  {
    path: '/order',
    name: 'OrdersManager',
    component: () => import('@/views/order/OrdersManager.vue'),
    meta: {
      title: 'order.title',
      pln: 0,
      action: 'TRIP_ACCOUNTING_VIEW',
      breadcrumb: [
        {
          text: 'action.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/order/:id',
    name: 'OrderView',
    component: () => import('@/views/order/OrderView.vue'),
    children: [
      {
        path: 'add',
        name: 'OrderViewAdd',
        meta: {
          title: 'order.title',
          pln: 1,
          action: 'TRIP_ACCOUNTING_ADD',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/order',
            },
            {
              text: 'action.duplicate',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'duplicate',
        name: 'OrderViewDuplicate',
        meta: {
          title: 'order.title',
          pln: 1,
          action: 'TRIP_ACCOUNTING_ADD',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/order',
            },
            {
              text: 'action.duplicate',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'show',
        name: 'OrderViewShow',
        meta: {
          title: 'order.title',
          pln: 1,
          action: 'TRIP_ACCOUNTING_VIEW',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/order',
            },
            {
              text: 'action.show',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
    ],
  },
]
